<div class="simulation-data">
    <div class="area-action">
        <h1>{{ 'Text_Simulations' | translate }}</h1>
        <div class="action-panel">
            <button mat-button isRoundButton="true" type="button" [attr.aria-label]="'+Add Simulation'" *ngIf="isSimuAdmin"
                (click)="openAddSimulationForm()" class="simu-main-button">
                <span>+{{ 'AddSimulation' | translate }}</span>
            </button>
            <mat-select required placeholder="{{ 'Simulations.FilterByOrganizations' | translate }}"
                class="simu-main-dropdown org-filter" (selectionChange)="onChangeOrg($event.value)" [(ngModel)]="orgId"
                name="orgId" [disableOptionCentering]="true" panelClass="drop-panel">
                <mat-option *ngFor="let org of listOrganization" [value]="org.id">
                    {{ org.name }}
                </mat-option>
            </mat-select>
        </div>
    </div>
    <div class="area-data">
        <div class="mat-elevation-z8 simulation-table">
            <div class="box-table hidden-sm">
                <table mat-table [dataSource]="dataSource">
                    <ng-container matColumnDef="simulationName">
                        <th mat-header-cell *matHeaderCellDef>{{ 'SimulationName' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.name }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Simulations.Code' | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.loginCode }}</td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Status' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="stt-cell">
                            <div class="stt-container" [ngSwitch]="element.status">
                                <div class="stt-data nstart-stt" *ngSwitchCase="ENUM_STATUS.NOT_STARTED">
                                    {{ 'NotStarted' | translate }}
                                </div>
                                <div class="stt-data running-stt" *ngSwitchCase="ENUM_STATUS.RUNNING">
                                    {{ 'Running' | translate }}
                                </div>
                                <div class="stt-data ended-stt" *ngSwitchCase="ENUM_STATUS.ENDED">
                                    {{ 'Ended' | translate }}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="participant">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Text_Participants' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="participant-data" (click)="openParticipantForm(element)">
                                {{ formatCellParticipant(element.participants) }}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Simulations.Type' | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.simulationTypeName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="room">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Simulations.Room' | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.roomNumber }}</td>
                    </ng-container>
                    <ng-container matColumnDef="availability">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Simulations.Avaliability' | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ formatCell('availability', element) }}</td>
                    </ng-container>

                    <ng-container matColumnDef="min">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Simulations.Min' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <span *ngIf="element.status == ENUM_STATUS.NOT_STARTED">-</span>
                            <app-duration [date]="element.startAtTime"
                                *ngIf="element.status == ENUM_STATUS.RUNNING"></app-duration>
                            <span *ngIf="element.status == ENUM_STATUS.ENDED"> {{ formMatCellMin(element) }}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="datetime">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Simulations.DateTime' | translate }}</th>
                        <td mat-cell *matCellDef="let element" [innerHTML]="getTemplateDateTime(element)"></td>
                    </ng-container>
                    <ng-container matColumnDef="copy">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Simulations.Copy' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-button class="btn-action btn-stop"
                                (click)="copyToClipboard(element.link)">Copy</button>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="width: 200px"></th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-button
                                *ngIf="element.status == ENUM_STATUS.NOT_STARTED && createdBy == element.createdBy"
                                class="btn-action btn-edit" (click)="btnClickAction('edit', element)">
                                {{ 'Btn_Edit' | translate }}
                            </button>
                            <button mat-button
                                *ngIf="element.status == ENUM_STATUS.NOT_STARTED && createdBy == element.createdBy"
                                class="btn-action btn-start now" (click)="btnClickAction('start now', element)">
                                {{ 'Btn_StartNow' | translate }}
                            </button>
                            <button mat-button *ngIf="element.status == ENUM_STATUS.RUNNING" class="btn-action btn-join"
                                (click)="btnClickAction('join', element)">
                                {{ 'Btn_Join' | translate }}
                            </button>
                            <button mat-button
                                *ngIf="element.status == ENUM_STATUS.RUNNING && createdBy == element.createdBy"
                                class="btn-action btn-stop" (click)="btnClickAction('stop', element)">
                                {{ 'Btn_Stop' | translate }}
                            </button>
                            <button mat-button *ngIf="element.status == ENUM_STATUS.ENDED"
                                class="btn-action btn-view log" (click)="btnClickAction('view log', element)">
                                {{ 'Btn_ViewLog' | translate }}
                            </button>
                            <button mat-button *ngIf="element.status == ENUM_STATUS.ENDED"
                                class="btn-action btn-view log" (click)="btnClickAction('Download PDF', element)">
                                {{ 'Download PDF' | translate }}
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
            <div class="mat-elevation-z8 expansion-table hidden-xs">
                <div *ngFor="let item of dataSource.data">
                    <app-expansion-item [data]="item" [openParticipantForm]="openParticipantForm"
                        [formatCellParticipant]="formatCellParticipant" [formatCell]="formatCell"
                        [formMatCellMin]="formMatCellMin" [getTemplateDateTime]="getTemplateDateTime"
                        [btnClickAction]="btnClickAction"></app-expansion-item>
                </div>
            </div>
            <div class="list" [hidden]="true">
                <ul>
                    <li *ngFor="
                            let item of dataSource.data
                                | paginate: { itemsPerPage: pageSize, currentPage: activePage, totalItems: totalItems }
                        ">
                        {{ item }}
                    </li>
                </ul>
            </div>

            <div class="d-flex align-items-center justify-content-center" style="margin-top: 50px">
                <span class="first-page" [ngClass]="activePage == 1 || maxPage == 0 ? 'disable' : ''"
                    (click)="onFirstPageClick()">{{ 'First' | translate }}</span>
                <pagination-controls (pageChange)="paginate($event)" class="d-inline-flex align-items-center"
                    responsive="true" previousLabel="" nextLabel="">
                </pagination-controls>
                <span class="last-page" [ngClass]="activePage == maxPage || maxPage == 0 ? 'disable' : ''"
                    (click)="onLastPageClick()">{{ 'Last' | translate }}</span>
            </div>
        </div>
    </div>
</div>
